import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class AdmissionFAQComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
